<div class="grid field col-12">
  @if (messages.length > 0) {
    <div class="grid field col-12">
      @for (m of messages; track m; let i = $index) {
        <p-message
          [severity]="toMessageSeverity(m.severity)"
          >{{ m.summary ? (m.detail ? m.summary + ': ' + m.detail : m.summary) : m.detail }}
        </p-message>
      }
    </div>
  }

  <div class="grid field col-12">
    <div class="col-12 md:col-12"><h2 style="margin-bottom:2px; padding-bottom:0px;">Post Job Analysis</h2></div>
  </div>

  <div class="grid field col-12">
    <div class="col-6 md:col-1">
      <label>Start</label>
    </div>
    <div class="col-6 md:col-3">
      <p-date-picker
        [(ngModel)]="calendarStartTime"
        [showIcon]="true"
        [showTime]="true"
        hourFormat="24"
        yearRange="2018:2038">
        @if (!calendarStartTime) {
          <div class="grid field col-12">
            <label style="color:red; font-weight:bold;">Start Time is required!</label>
          </div>
        }
      </p-date-picker>
    </div>
    <div class="col-6 md:col-1">
      <label>End</label>
    </div>
    <div class="col-6 md:col-3">
      <p-date-picker
        [(ngModel)]="calendarEndTime"
        [showIcon]="true"
        [showTime]="true"
        hourFormat="24"
        yearRange="2018:2038">
        @if (!calendarStartTime) {
          <div class="grid field col-12">
            <label style="color:red; font-weight:bold;">Start Time is required!</label>
          </div>
        }
      </p-date-picker>
    </div>
  </div>
  <div class="grid field col-12">
    @if (everythingReady) {
      <div class="col-4 md:col-2">
        <button pButton type="button" (click)="searchJobs()" style="width:100px; margin-top:20px; float:right; vertical-align:bottom;">
          <span pButtonLabel>Search</span>
        </button>
      </div>
    }
    <div class="col-4 md:col-2">
      <button pButton type="button" (click)="clearSelection()" style="width:100px; margin-top:20px; float:right; vertical-align:bottom;">
        <span pButtonLabel>{{clearString}}</span>
      </button>
    </div>
    @if (everythingReady) {
      <div class="col-4 md:col-3">
        <button pButton type="button" (click)="runAnalysis()" style="width:200px; margin-top:20px; float:right; vertical-align:bottom;">
          <span pButtonLabel>Analyze</span>
        </button>
      </div>
    }
  </div>
  <div class="grid field col-12">
    <p-table #dt [columns]="cols" [value]="jobs" [scrollable]="true" [loading]="!everythingReady" [(selection)]="selectedJobs" dataKey="id" (onRowSelect)="updateClearString()" (onRowUnselect)="updateClearString()">
      <ng-template #colgroup let-columns>
        <colgroup>
        <col />
        @for (col of columns; track col) {
          <col [style.width]="col.width"/>
        }
      </colgroup>
    </ng-template>
    <ng-template #header let-columns>
      <tr>
        <th style="width:3em;">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field">
            {{col.header}}
            @if (col.field != '') {
              <p-sortIcon [field]="col.field"></p-sortIcon>
            }
          </th>
        }
      </tr>
      <tr>
        <th></th>
        @for (col of columns; track col) {
          <th>
            @switch (col.field) {
              @case ('name') {
                <div>
                  <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;" />
                </div>
              }
              @case ('company.name') {
                <div>
                  <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;" />
                </div>
              }
              @case ('devices') {
                <div style="width: 100%;">
                  <input pInputText type="text" (input)="dt.filter($event.target.value, col.alternativeFilterField, col.filterMatchMode)" style="width: 100%;" />
                </div>
              }
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-job>
      <tr [pSelectableRow]="job">
        <td style="width:3em;">
          <p-tableCheckbox [value]="job" ></p-tableCheckbox>
        </td>
        <td>{{job.name}}</td>
        <td>{{(job.company) ? job.company.name : "" }}</td>
        <td>{{job.startTime | date: 'short'}}</td>
        <td>{{job.endTime | date: 'short'}}</td>
        <td>{{job.deviceNamesAsString}}</td>
      </tr>
    </ng-template>
    <ng-template #paginatorleft>
      Showing {{(dt.totalRecords) < 1 ? 0 : ((dt.first ?? 0) + 1)}} to
      {{(dt.totalRecords) > 0 ? (((dt.rows ?? 0) + (dt.first ?? 0)) <= (dt.totalRecords) ? ((dt.rows ?? 0) + (dt.first ?? 0)) :
      (dt.totalRecords)) : 0}} of {{dt.totalRecords}} entries
    </ng-template>
  </p-table>
</div>
</div>

